import { Routes, Route } from 'react-router-dom';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

//old - will remove eventually
// import ClubRegistrationContextProvider from '../../state/clubRegistration/ClubRegistrationContextProvider';

//new - should replace old one above
import ClubRegistrationNewContextProvider from '../../state/clubRegistrationNew/ClubRegistrationNewContextProvider';

import ClubRegistrationNavContextProvider from '../../state/clubRegistration/leftNavigation/ClubRegistrationNavContextProvider';
import ClubRegistrationPaymentContextProvider from '../../state/clubRegistration/payment/ClubRegistrationPaymentContextProvider';
import UsasClubStaffContextProvider from '../../state/clubStaff/UsasClubStaffContextProvider';
import UsasClubFacilityLinksContextProvider from '../../state/clubFacilityLinks/UsasClubFacillityLinksContextProvider';
import UsasClubPreCompLinksContextProvider from '../../state/clubPreCompLinks/UsasClubPreCompLinksContextProvider';
import PreCompLocationContextProvider from '../../state/preCompLocation/PreCompLocationContextProvider';

import OfferingTypesContextProvider from '@usas/ui-web/state/offeringTypes/OfferingTypesContextProvider';
import MemberRegistrationHistoryContextProvider from '@usas/ui-web/state/offeringTypes/MemberRegistrationHistoryContextProvider';
import PreCompOrganizationContextProvider from '@usas/ui-web/state/preCompOrganization/PreCompOrganizationContextProvider';
import PreCompSearchFilterContextProvider from '@usas/ui-web/state/preCompOrganization/PreCompSearchFilterContextProvider';
import SearchPreCompContextProvider from '@usas/ui-web/state/searchPreComp/SearchPreCompContextProvider';
import FacilityContextProvider from '@usas/ui-web/state/facility/FacilityContextProvider';
import FacilityFiltersContextProvider from '@usas/ui-web/state/facility/FacilityFiltersContextProvider';
import SearchFacilityContextProvider from '@usas/ui-web/state/searchFacility/SearchFacilityContextProvider';
import LeftNavModalContextProvider from '@usas/ui-web/state/leftNavModal/LeftNavModalContextProvider';

import ClubRegistrationEntryNew from './clubRegistrationEntry/ClubRegistrationEntryNew';
import ClubRegistrationDisclaimer from './clubRegistrationDisclaimer/ClubRegistrationDisclaimer';
import ClubRegistrationInfo from './clubRegistrationInfo/ClubRegistrationInfo';
import NewClubRegistrationStaff from './newClubRegistrationStaff/NewClubRegistrationStaff';
import NewClubRegistrationStaffDetail from './newClubRegistrationStaff/NewClubRegistrationStaffDetail';
// import ClubRegistrationStaff from './clubRegistrationStaff/ClubRegistrationStaff';
// import ClubRegistrationStaffDetail from './clubRegistrationStaff/ClubRegistrationStaffDetail';
import ClubRegistrationLegalEntities from './clubRegistrationLegalEntities/ClubRegistrationLegalEntities';
import ClubRegistrationLegalEntitiesDetail from './clubRegistrationLegalEntities/ClubRegistrationLegalEntitiesDetail';
import ClubRegistrationScreeningPolicies from './clubRegistrationScreeningPolicies/ClubRegistrationScreeningPolicies';
import ClubRegistrationFacilities from './clubRegistrationFacilities/ClubRegistrationFacilities';
import ClubRegistrationFacilityDetails from './clubRegistrationFacilities/ClubRegistrationFacilityDetails';
import ClubRegistrationFacilitySearch from './clubRegistrationFacilities/ClubRegistrationFacilitySearch';
import ClubRegistrationFacilityAdd from './clubRegistrationFacilities/ClubRegistrationFacilityAdd';
import ClubRegistrationFacilityPoolDetail from './clubRegistrationFacilities/ClubRegistrationFacilityPoolDetail';
import ClubRegistrationMissionStatementBudget from './clubRegistrationMissionStatementBudget/ClubRegistrationMissionStatementBudget';
// import ClubRegistrationEmergencyPlan from './clubRegistrationEmergencyPlan/ClubRegistrationEmergencyPlan';
import ClubRegistrationSubmit from './clubRegistrationSubmit/ClubRegistrationSubmit';

import PageNotFound from '@usas/ui-web/components/PageNotFound';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import OrgUnitSelection from './orgUnitSelection/OrgUnitSelection';
import SelectOrgUnitContextProvider from '@usas/ui-web/state/selectOrgUnit/SelectOrgUnitContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';
import BaseUsasClubContextProvider from '@usas/ui-web/state/clubBase/BaseUsasClubContextProvider';
import BaseUsasClubFiltersContextProvider from '@usas/ui-web/state/clubBase/BaseUsasClubFiltersContextProvider';
import LegalEntityTypeContextProvider from '../../state/legalEntity/LegalEntityTypeContextProvider';

const ClubRegistrationRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <Routes>
      <Route path={navRoutes['CLUB_REGISTRATION_SELECTION']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_SELECTION']}
            editElement={<OrgUnitSelection />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_ENTRY_NEW']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_ENTRY_NEW']}
            editElement={<ClubRegistrationEntryNew />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_DISCLAIMER']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_DISCLAIMER']}
            editElement={<ClubRegistrationDisclaimer />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_INFO']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_INFO']}
            editElement={<ClubRegistrationInfo />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_STAFF']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_STAFF']}
            editElement={<NewClubRegistrationStaff />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_STAFF_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_STAFF_DETAIL']}
            editElement={<NewClubRegistrationStaffDetail />} />
        } />

      {/* <Route path={navRoutes['CLUB_REGISTRATION_STAFF']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_STAFF']}
            editElement={<ClubRegistrationStaff />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_STAFF_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_STAFF_DETAIL']}
            editElement={<ClubRegistrationStaffDetail />} />
        } /> */}
      <Route path={navRoutes['CLUB_REGISTRATION_LEGAL_ENTITY']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_LEGAL_ENTITY']}
            editElement={<ClubRegistrationLegalEntities />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_LEGAL_ENTITY_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_LEGAL_ENTITY_DETAIL']}
            editElement={<ClubRegistrationLegalEntitiesDetail />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_SCREENING_POLICIES']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_SCREENING_POLICIES']}
            editElement={<ClubRegistrationScreeningPolicies />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_FACILITY']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_FACILITY']}
            editElement={<ClubRegistrationFacilities />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_FACILITY_SEARCH']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_FACILITY_SEARCH']}
            editElement={<ClubRegistrationFacilitySearch />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_FACILITY_ADD']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_FACILITY_ADD']}
            editElement={<ClubRegistrationFacilityAdd />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_FACILITY_DETAILS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_FACILITY_DETAILS']}
            editElement={<ClubRegistrationFacilityDetails />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_FACILITY_POOL_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_FACILITY_POOL_DETAIL']}
            editElement={<ClubRegistrationFacilityPoolDetail />} />
        } />
      <Route path={navRoutes['CLUB_REGISTRATION_MISSION_STATEMENT_BUDGET']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_MISSION_STATEMENT_BUDGET']}
            editElement={<ClubRegistrationMissionStatementBudget />} />
        } />
      {/* <Route path={navRoutes['CLUB_REGISTRATION_EMERGENCY_PLAN']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_EMERGENCY_PLAN']}
            editElement={<ClubRegistrationEmergencyPlan />} />
        } /> */}
      <Route path={navRoutes['CLUB_REGISTRATION_SUBMIT']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['CLUB_REGISTRATION_SUBMIT']}
            editElement={<ClubRegistrationSubmit />} />
        } />

      <Route path={'/'} element={<Navigate to={navRoutes['CLUB_REGISTRATION_ENTRY_NEW']?.path} replace />} />
      <Route path={'/*'} element={<PageNotFound />} />
    </Routes>
  );
};

const ClubRegistration = () => (
  <BaseUsasClubContextProvider>
    <BaseUsasClubFiltersContextProvider>
      <SelectOrgUnitContextProvider>
        <PersonOrgRoleContextProvider>
          <LeftNavModalContextProvider>
            {/* <ClubRegistrationContextProvider> */}
              <ClubRegistrationNewContextProvider>
                <ClubRegistrationPaymentContextProvider>
                  <UsasClubStaffContextProvider>
                    <UsasClubFacilityLinksContextProvider>
                      <UsasClubPreCompLinksContextProvider>
                        <OfferingTypesContextProvider>
                          <MemberRegistrationHistoryContextProvider>
                            <LegalEntityTypeContextProvider>
                              <PreCompOrganizationContextProvider>
                                <PreCompLocationContextProvider>
                                  <PreCompSearchFilterContextProvider>
                                    <SearchPreCompContextProvider>
                                      <FacilityContextProvider>
                                        <FacilityFiltersContextProvider>
                                          <SearchFacilityContextProvider>
                                            <ClubRegistrationNavContextProvider>
                                              <ClubRegistrationRoutes />
                                            </ClubRegistrationNavContextProvider>
                                          </SearchFacilityContextProvider>
                                        </FacilityFiltersContextProvider>
                                      </FacilityContextProvider>
                                    </SearchPreCompContextProvider>
                                  </PreCompSearchFilterContextProvider>
                                </PreCompLocationContextProvider>
                              </PreCompOrganizationContextProvider>
                            </LegalEntityTypeContextProvider>
                          </MemberRegistrationHistoryContextProvider>
                        </OfferingTypesContextProvider>
                      </UsasClubPreCompLinksContextProvider>
                    </UsasClubFacilityLinksContextProvider>
                  </UsasClubStaffContextProvider>
                </ClubRegistrationPaymentContextProvider>
              </ClubRegistrationNewContextProvider>
            {/* </ClubRegistrationContextProvider> */}
          </LeftNavModalContextProvider>
        </PersonOrgRoleContextProvider>
      </SelectOrgUnitContextProvider>
    </BaseUsasClubFiltersContextProvider>
  </BaseUsasClubContextProvider>
);

export default ClubRegistration;